import { useInfoCard } from '../hooks/useInfoCard';

export function InfoCardHeadline() {
	const { isFullModeStyle, textPosition, headline, handles } = useInfoCard();

	if (!headline) return null;

	function renderTokens(): string {
		const textAlignToken = textPosition === 'right' ? 'tr' : textPosition === 'left' ? 'tl' : 'tc';

		if (isFullModeStyle) {
			return textAlignToken;
		}

		return 'tl';
	}

	function renderStyles() {
		return { display: 'contents' };
	}

	return (
		<div className={`${handles.infoCardHeadline} t-heading-2 mt6 ${renderTokens()} c-on-base mw-100`}>
			<div style={renderStyles()}>{headline}</div>
		</div>
	);
}
